import { motion } from 'framer-motion'
import { SectionWrapper, Badge } from '../components/primitives/index.js'
import { useProducts } from '../context/ProductsContext.jsx'
import './PeptideHallOfFame.css'

const EASE = [0.16, 1, 0.3, 1]

const DEFAULTS = {
  eyebrow: 'Hall of Fame',
  heading: 'The sequences that changed the field.',
  body: 'A selection of the most studied peptide sequences in research — chosen for documented receptor activity and reproducible findings across published literature.',
}

export default function PeptideHallOfFame() {
  const { hallOfFame, siteContent } = useProducts()
  if (!hallOfFame.length) return null
  const c = { ...DEFAULTS, ...(siteContent?.hofHeader ?? {}) }

  return (
    <SectionWrapper id="hall-of-fame" className="hof container">
      <div className="hof__header">
        <span className="hof__eyebrow">{c.eyebrow}</span>
        <h2>{c.heading}</h2>
        <p>{c.body}</p>
      </div>

      <div className="hof__grid">
        {hallOfFame.map((p, i) => (
          <motion.article
            key={p.code}
            className="hof__card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-10%' }}
            transition={{ duration: 0.5, delay: i * 0.06, ease: EASE }}
          >
            <div className="hof__card-top">
              <div>
                <p className="hof__code">{p.code}</p>
                <p className="hof__name">{p.name}</p>
              </div>
              <Badge tone="neutral">{p.tag}</Badge>
            </div>

            <div className="hof__divider" />

            <p className="hof__description">{p.description}</p>

            <div className="hof__stats">
              {p.stats.map((s) => (
                <div key={s.label}>
                  <p className="hof__stat-label">{s.label}</p>
                  <p className="hof__stat-value">{s.value}</p>
                </div>
              ))}
            </div>
          </motion.article>
        ))}
      </div>
    </SectionWrapper>
  )
}
